import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { SessionService, LookupsService, ConstantsService, LotStatusEnum, AccountService, EnvironmentService } from '@app/base/core';
import { Marker, StepsIdEnum, RequestServiceModel, BuilderInfo, BCASearch } from '@app/base/core/models';
import { BuilderService } from '@app/modules/builder';
import { SocoHttpService, SocoConfigurationService } from '@app/base/soco';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GasRequestModel } from '@app/shared/models/applicant/new.model';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { triggerFormValidation, focusFirstInvalidField } from '@app/base/shared';
import { DatePipe } from '@angular/common';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-lot',
  templateUrl: './lot.component.html',
  styleUrls: ['./lot.component.css']
})
export class LotComponent implements OnInit {
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  mapIntegration: any;
  MandateMsg: boolean;
  builderNoOfLotsForm: FormGroup;
  router: Router;
  model: RequestServiceModel[] = [];
  public dropdownSettings = {};
  public mapTypeControl: any;
  public google: any;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public markerDraggable = false;
  public marker: Marker;
  public showMarker = false;
  public modelGasBca: GasRequestModel;

  public lat: number;
  public long: number;
  public resetBcadata = false;
  public infoWindowOpen: boolean;
  public labelOptions: any;
  public propertyType: string;
  public AlllotNum: any[] = [];
  public mapTypeId: string;
  public errorMsg: string;
  public addressFromMarker: any;
  public showAddress = true;
  public routeParamFlag;
  public address: any;
  public info: any;
  public totalLots: number;
  public killsubscribe: boolean;
  public newLot = 1;
  public index;
  public lotNumber: number[] = [];
  public orignalLots: number;
  public state: string;
  public city: string;
  public setTime;
  public streetname: string;
  public streetnumber: string;
  public countLots: number;

  myForm: FormGroup;
  public addSuccess: boolean;
  public GridId: string;
  public userId: string;
  public routeSubscription: any;
  public builderId: string;
  public stateCd: string;
  public bcaData: any = [];
  public gisMapUrl: SafeResourceUrl;
  public rowValue;
  public projectAddress = false;
  public urlWithParameters: any;
  public getLotDetailsSubscription: Subscription;
  public lotsSubscription: Subscription;

  streetTypes = [];
  selectedStreetTypes = [];
  selectedCities = [];
  cities = [];
  selectedStates = [];
  states = [];
  imageURL: 'http://iconbug.com/download/size/128/icon/6329/small-home/';
  @ViewChild('search', {static: false})
  public searchElementRef: ElementRef;
  @ViewChild('infowindow', {static: false})
  public infoWindow;
  public builderInfo: BuilderInfo = {
    Admin: false,
    BuilderId: [],
    subsidiaryId: [],
    IsActive: '',
    CompanyName: '',
    subsidiaryList: [],
    CompanyAddress: {
    id: '',
    recUpdatedDate: '',
    recCreatedDate: '',
    recCreatedBy: '',
    recUpdatedBy: '',
    contactTypeCode: '',
    streetNumber: '',
    streetName: '',
    directionPrefix: '',
    directionSuffix: '',
    streetType: '',
    city: '',
    state: '',
    zipCode: '',
    contactName2Extn: '',
    contactName1Phone: '',
    contactName1AreaCode: '',
    contactName2AreaCode: '',
    contactName2Phone: '',
    address2: '',
    unitNumber: ''
  },
    CompanyEmail: '',
  //  AdminUsers:  [{ firstName: '', lastName: '', userId: '', builderId: '', email: ''}],
    BuilderMapping: [{id: '', builderName: '', subsidiaryId: [], subsidiaryName: [], status: '' }]
};
  // pattern
  date1 = new Date('04/09/2018');
  date2 = new Date('04/09/2019');
  public builderidArray;
  public projectNumber;
  public refreshFlag = false;
  public notvalid = false;
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: '',
    projectAddress: '',
    bcaStatus: '',
    subsidaryId: '',
    subsidarycompanyName: '',
    startDate: this.date1,
    endDate: this.date2,
    reqId: '',
    bcaStatusValue: ''
  };
  public grStatus: any;
  public grTypeCd: any;
  public cityValues = null;
  public stateValues = null;

  public builderDetailsSubscription: Subscription;
  numericPattern = /^[0-9]*$/;
  constructor(
    public sessionSvc: SessionService,
    private builderSvc: BuilderService,
    public lookupSvc: LookupsService,
    public constSvc: ConstantsService,
    public socoHttp: SocoHttpService,
    public sanitizer: DomSanitizer,
    public accountSvc: AccountService,
    public route: ActivatedRoute, private datePipe: DatePipe,
    _router: Router,
    public environmentSvc: EnvironmentService,
  ) {
      this.router = _router;
      this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Value',
      enableSearchFilter: true
    };
    this.zoom = 5;
    this.latitude = 37.1147781;
    this.longitude = -96.1683426;
    this.urlWithParameters = this.environmentSvc.gisURL;
    this.userId = this.accountSvc.account.user.username;
    this.cityValues = this.lookupSvc.cities;
    this.stateValues = this.lookupSvc.states;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.id === 1) {
        this.refreshFlag = true;
        this.routeSubscription = this.route.params.subscribe(params => {
          if (params['id']) {
            this.rowValue = (params['id']);
          }
          if (params['navFlag']) {
            this.routeParamFlag = (params['navFlag']);
          }
        });
        if (this.routeParamFlag === 's-rl') {
        this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).pipe(takeWhile(() => this.killsubscribe)).subscribe(result => {
          if (result.data.length !== 0) {
            this.builderInfo.BuilderId.push(result.data.id);
              this.builderInfo.Admin = true;
              for (let i = 0; i < result.data.builderMapping.length; i++) {
                  this.builderInfo.BuilderId.push(result.data.builderMapping[i].subsidiaryId);
              }
            this.builderidArray = this.builderInfo.BuilderId;
          }

                for (let i = 0; i < this.builderidArray.length; i++) {
                  this.bcaSearch.builderId.push(this.builderidArray[i]);
                }
                this.bcaSearch.reqId = this.rowValue;
                this.builderDetailsSubscription = this.builderSvc.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
                  if (result.data[0].bcaId !== undefined) {
                    this.projectNumber = result.data[0].bcaId;
                  }
                  this.grStatus = result.data[0].grStatus;
                  this.grTypeCd = result.data[0].gasRqstTpCd;
                  this.notvalid = this.isProjectNumber();
                  if (this.notvalid === true) {
                    this.router.navigate([
                      this.sessionSvc.paramLdc.toLowerCase(),
                      'builder',
                      'home'
                      ]);
                    }
                });
            });
          } else {
            this.router.navigate([
              this.sessionSvc.paramLdc.toLowerCase(),
              'builder',
              'home'
              ]);
          }
        }
        });
  }
  ngOnInit() {
    this.killsubscribe = true;
    window.scroll(0, 100);
    this.stateCd = this.sessionSvc.paramLdc;

    // To get gas request Id from route params
    this.routeSubscription = this.route.params.subscribe(params => {
      if (params['id']) {
        this.GridId = (params['id']);
      }
      if (params['builderId']) {
        this.builderId = (params['builderId']);
      }
      if (params['navFlag']) {
        this.routeParamFlag = (params['navFlag']);
      }
    });

    this.myForm = new FormGroup({
       serviceCity: new FormControl({value: null, disabled: true}),
       serviceState: new FormControl({value: null, disabled: true}),
       serviceZip: new FormControl({value: null, disabled: true},
         Validators.pattern(this.constSvc.zipCodePattern)),
         lotDetails: new FormArray([new FormGroup({
           serviceStreetNumber: new FormControl(null, [Validators.pattern(this.constSvc.numericPatternwithZero), Validators.required]),
           serviceStreetName: new FormControl(null, [Validators.required, Validators.pattern(this.constSvc.alphaNumericPattern)]),
          lotNo: new FormControl(null, [Validators.pattern(this.constSvc.numericPattern), Validators.required])
        })])
      });
        this.sessionSvc.BcaData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
          if (success !== null) {
            this.bcaData = success;
          }
        });
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
      if (this.refreshFlag === true) {
     const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
        if (subscribe && val) {
          subscribe.unsubscribe();
        }
        if (val) {
          this.cityValues = this.lookupSvc.cities;
          this.stateValues = this.lookupSvc.states;
          this.getlotNumber();
          this.getLots();
        this.showMarker = false;
        this.setCurrentPosition();
        }
      });
      } else {
        this.getlotNumber();
        this.getLots();
      this.showMarker = false;
      this.setCurrentPosition();
     }


  }
  // unsubscribibg subscriptions
 ngOnDestroy() {
   if (this.addSuccess === true ) {
    this.killsubscribe = false;
   }
   this.routeSubscription.unsubscribe();
   if ( this.lotsSubscription) {
    this.lotsSubscription.unsubscribe();
   }
   if ( this.getLotDetailsSubscription) {
    this.getLotDetailsSubscription.unsubscribe();
   }
   clearInterval(this.setTime);
 }

  gisMap() {
     // Start--Loading the GIS read-only map
     this.urlWithParameters += this.modelGasBca.id;
     this.urlWithParameters += '&state=' + this.stateCd;
     this.gisMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlWithParameters);
     // End--Loading the GIS read-only map

  }
// code to fetch lot numbers for the selected gas request Id
  getlotNumber() {
    this.countLots = 0;
    this.getLotDetailsSubscription = this.builderSvc.GetLotDetails(this.GridId).subscribe(result => {
      for (let i = 0; i < result.data.length; i++) {
        this.lotNumber.push(result.data[i].lotNumber);
        result.data[i].isManualLotRequested === 'Y' ? this.countLots += 1 : null;
      }
     });
  }
// code to fetch address details for the selected gas request Id
  getLots() {
    this.lotsSubscription = this.builderSvc.Lots(Number(this.GridId)).subscribe(result => {
      if (result) {
        this.modelGasBca = result.data;
      if (this.modelGasBca.cityId !== null && this.modelGasBca.stateCd !== null && this.modelGasBca.zipCode !== null &&
        this.modelGasBca.serviceFormattedAddress !== null) {
          this.totalLots = Number(result.data.finalPlat);
          this.orignalLots = result.data.totalLots;
          this.gisMap();
            if (this.cityValues !== undefined && this.stateValues !== undefined) {
              this.city = this.cityValues.find(x => Number(x.id) === this.modelGasBca.cityId).itemName;
              this.state  = this.stateValues.find(x => x.id === this.modelGasBca.stateCd).itemName;
            }
            this.socoHttp.hidePleaseWait('ContainerAwaiter');
            this.myForm.patchValue({
              serviceCity:  this.city,
             serviceState: this.state,
             serviceZip: this.modelGasBca.zipCode,
          });
        } else {
          swal(this.constSvc.lotSwal1, this.constSvc.lotSwal2, this.constSvc.errorSwal);
      this.projectAddress = true;
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
        }
    } else {
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
    }
  },
  (error) => {
    swal(this.constSvc.errorSwal1, this.constSvc.gasDetailsFailSwal, this.constSvc.errorSwal);
    this.socoHttp.hidePleaseWait('ContainerAwaiter');
  });
  }

// Add FormGroup to Contact Details form Array in Information page.
    add() {
      const formArray = <FormArray>this.myForm.controls['lotDetails'];
      const val = this.constSvc.addMaxLot - this.countLots;
      if (formArray.length < val) {
      formArray.push(new FormGroup({
        serviceStreetNumber: new FormControl(null,
          [Validators.pattern(this.constSvc.numericPatternwithZero), Validators.required]),
        serviceStreetName: new FormControl(null, [Validators.required, Validators.pattern(this.constSvc.alphaNumericPattern)]),
           lotNo: new FormControl(null,
            [Validators.pattern(this.constSvc.numericPattern), Validators.required])
      }));

    } else {
      swal(this.constSvc.errorSwal1, this.constSvc.lotSwal3, this.constSvc.errorSwal);
    }
    }
// Delete FormGroup from Contact Details form Array based on the input  Array index id
    delete(id: number) {
      const formArray = <FormArray>this.myForm.controls['lotDetails'];
      formArray.removeAt(id);
    }
    // To get Service city from form
  get serviceCity() {
    return this.myForm.get('serviceCity');
  }
    // To get Service state from form
  get serviceState() {
    return this.myForm.get('serviceState');
  }
    // To get Service zip from form
  get serviceZip() {
    return this.myForm.get('serviceZip');
  }
    // To get Number of lots city from form
  get numberOfLots() {
     return this.myForm.get('numberOfLots');
   }
   // Formatting service address
   serviceAddress(formData) {
   return  formData.serviceStreetNumber + ' ' + formData.serviceStreetName + ', ' + this.serviceCity.value
   + ' ' + this.modelGasBca.stateCd + ' ' + this.serviceZip.value + ', USA ';
  }

  public isProjectNumber() {
    const grTypes = ['SUBD', 'SCATT'];
    const grStatuses = ['APPDENIED', 'APPPEND', 'PEND', 'APPACCPT'];
    if ((this.projectNumber == null) || (grStatuses.includes(this.grStatus)) || (!grTypes.includes(this.grTypeCd))) {
      return true;
    } else {
      return false;
    }
  }

// code to save lots information in DB
   public addlots(): void {
     this.addSuccess = false;
     const lotnum = [];
    const formArray = <FormArray>this.myForm.controls['lotDetails'];
    if ((this.countLots !==  this.constSvc.addMaxLot) ||
    (this.countLots > this.constSvc.addMaxLot)) {
        if (this.myForm.valid) {
        for (let i = 0; i < formArray.value.length; i++) {
          lotnum.push(Number(formArray.value[i].lotNo));
        }
        for (let i = 0; i < this.lotNumber.length; i++) {
        lotnum.push(this.lotNumber[i]);
        }
        if (lotnum.length !== new Set(lotnum).size) {
          this.addSuccess = true;
          swal(this.constSvc.errorSwal1, this.constSvc.lotSwal4, this.constSvc.errorSwal);
        } else {

         this.lotNumber = lotnum;

         for (let i = 0; i < formArray.value.length; i++) {

         const modelObj = new RequestServiceModel();
         modelObj.address = this.serviceAddress(formArray.value[i]);
         modelObj.city = this.city;
         modelObj.zip = this.serviceZip.value;
         modelObj.stateCd = this.modelGasBca.stateCd;
         modelObj.countyId = this.modelGasBca.countyId;
         modelObj.grId = this.modelGasBca.id;
         modelObj.builderId = this.builderId;
         modelObj.lotStatus = LotStatusEnum.RNL;
         modelObj.streetNo = formArray.value[i].serviceStreetNumber;
         modelObj.lotNumber = formArray.value[i].lotNo;
         modelObj.streetName = formArray.value[i].serviceStreetName;
         modelObj.recCreateDttm =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
         modelObj.recUpdateDttm =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
         modelObj.recCreateUsrId = this.userId;
         modelObj.recUpdateUsrId = this.userId;
         modelObj.lotStatusUpdatedBy = this.userId;
         modelObj.lotStatusUpdatedDate =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
         modelObj.isManualLotRequested = this.constSvc.manualLotRequested;
         this.model.push(modelObj);
         }
          this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
          window.scroll(0, 400);
          this.builderSvc.PostCreateLots(this.model).subscribe(result => {
              if (result) {
              this.countLots = this.countLots + this.model.length;
              this.addSuccess = true;
              this.checkBca();
             formArray.reset();
             formArray.controls = [];
             formArray.setValue([]);
             formArray.push(new FormGroup({
              serviceStreetNumber: new FormControl(null,
                 [Validators.pattern(this.constSvc.numericPatternwithZero), Validators.required]),
               serviceStreetName: new FormControl(null, [Validators.required, Validators.pattern(this.constSvc.alphaNumericPattern)]),
                 lotNo: new FormControl(null,
                  [Validators.pattern(this.constSvc.numericPattern), Validators.required])
            }));

              this.socoHttp.hidePleaseWait('ContainerAwaiter');
              this.model = [];
              swal(this.constSvc.lotCreationReqSwal, this.constSvc.lotCreationSuccessSwal, this.constSvc.successSwal);
             } else  {
               this.socoHttp.hidePleaseWait('ContainerAwaiter');
               this.addSuccess = true;
               swal(this.constSvc.lotCreationReqSwal, this.constSvc.lotCreationFailSwal, this.constSvc.errorSwal);
            }
           },
           (error) => {
            this.socoHttp.hidePleaseWait('ContainerAwaiter');
            swal(this.constSvc.lotCreationReqSwal, this.constSvc.lotCreationFailSwal, this.constSvc.errorSwal);
           });

     }} else  {
       this.socoHttp.hidePleaseWait('ContainerAwaiter');
       this.addSuccess = true;
          swal(this.constSvc.lotCreationReqNotSubSwal, this.constSvc.checkAllFieldsSwal, this.constSvc.errorSwal);
          triggerFormValidation(this.myForm);
          focusFirstInvalidField(this.myForm);

   }

    } else {
      this.addSuccess = true;
      swal(this.constSvc.errorSwal1, this.constSvc.lotSwal3, this.constSvc.errorSwal);
    }

  }
  // code to pass updated final plat to landing page after successful submission
  // code not used now

  // passBcaData() {
  //   if (this.resetBcadata === false) {
  //     if (this.index !== undefined) {
  //       this.bcaData[this.index].finalPlat = String(this.totalLots);
  //       this.sessionSvc.GetBcaData(this.bcaData);

  //     }

  //   } else { this.sessionSvc.GetBcaData(null); }

  //   }

// code to check BCA exists or not
checkBca() {
  if (this.bcaData.length !== 0) {
  for (let i = 0; i < this.bcaData.length; i++) {
    if (this.bcaData[i].id === Number(this.GridId)) {
      this.resetBcadata = false;
      this.index = i;
      break;
    } else {
      this.resetBcadata = true;
    }
  }
} else {
  this.resetBcadata = true;
}
}
// Validating Form Fields
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // Gis Map Methods
  setCurrentPosition() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 14;
      });
      this.showMarker = true;
      // change value to true to show confirm and cancle button on  user location  on map load
      this.infoWindowOpen = false;
      // change Marker label options
      this.labelOptions = {
        color: '#000',
        icon: this.imageURL,
        imageUrl: this.imageURL,
        image: this.imageURL,
        fontFamily: '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: 'H'
      };
    }
  }
  // code to route to previous tab
  goToPrevious() {
    let a;
    a = this.routeParamFlag;

    if (a === 'blr-rl') {
      const substr: number = this.router.url.indexOf('builder') + 7;
      const str = this.router.url.slice(0, substr);
      if (this.builderId) {
         this.router.navigate([str + '/' + 'requestlot/' + this.GridId + '/' + this.routeParamFlag]);
      }

    } else if (a === 's-rl') {
      const substr: number = this.router.url.indexOf('builder') + 7;
      const str = this.router.url.slice(0, substr);
      this.router.navigate([str + '/' + 'request/' + this.GridId +
       '/' + 'service' ]);
    }

  }
  // To go to builder home page
  navigateHome() {
    this.sessionSvc.GetBcaData(null);
    this.router.navigate([
      this.sessionSvc.paramLdc.toLowerCase(),
      'builder',
      'home'
      ]);
  }

}
